import { toast } from "react-toastify";

import {
  DeleteOrgSecretRequestPathParamsType,
  DeleteOrgSecretResponseBodyType,
  ListOrgSecretsResponseBodyType,
} from "@intelligems/ig-types";
import { getMutationErrorMessage } from "@src/queryClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { orgSecretKeys, shippingProviderKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const deleteOrgSecret = async (
  payload: ApiRequest<unknown, DeleteOrgSecretRequestPathParamsType>
) => {
  const resp = await api.delete<DeleteOrgSecretResponseBodyType>(
    `/v2/org-secrets/${payload.pathParams.id}`
  );
  return resp.data;
};

export const useDeleteOrgSecret = () => {
  const queryClient = useQueryClient();

  return useMutation<
    DeleteOrgSecretResponseBodyType,
    Error,
    ApiRequest<unknown, DeleteOrgSecretRequestPathParamsType>,
    unknown
  >({
    mutationFn: async (data) => deleteOrgSecret(data),
    onSuccess: async (_, variables) => {
      queryClient.setQueryData<ListOrgSecretsResponseBodyType | undefined>(
        orgSecretKeys.all,
        (currentData) => {
          if (!currentData) {
            return { secrets: [] };
          }
          return {
            secrets: currentData.secrets.filter(
              (secret) => secret.id !== variables.pathParams.id
            ),
          };
        }
      );

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: orgSecretKeys.all }),
        queryClient.invalidateQueries({ queryKey: shippingProviderKeys.all }),
      ]);
    },
    onError: (error) => {
      const errorDetail = getMutationErrorMessage(error);
      toast.error(
        `Failed to delete secret${errorDetail ? `. ${errorDetail}` : ""}`
      );
    },
  });
};
